interface DashboardPreviewProps {
  animatedMetrics: {
    marbling: number;
    accuracy: number;
  };
}

const DashboardPreview = ({ animatedMetrics }: DashboardPreviewProps) => {
  return (
    <div className="hero-visual">
      <div className="dashboard-preview data-processing-indicator floating-element">
        <div className="preview-header">
          <div className="preview-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
          <div>
            <span className="preview-title">MEQ Carcase Solutions</span>
            <div className="preview-status">GRADING</div>
          </div>
        </div>
        
        <div className="preview-content">
          <div className="preview-chart">
            <div className="chart-title">
              <span className="chart-live-indicator"></span>
              USDA Grading Distribution
            </div>
            <div className="chart-bars">
              <div className="bar grey" style={{ height: '30%' }}></div>
              <div className="bar" style={{ height: '20%' }}></div>
              <div className="bar grey" style={{ height: '52%' }}></div>
              <div className="bar" style={{ height: '60%' }}></div>
              <div className="bar grey" style={{ height: '20%' }}></div>
              <div className="bar" style={{ height: '30%' }}></div>
            </div>
            <div className="chart-labels">
              <span></span>
              <span>Select</span>
              <span></span>
              <span>Choice</span>
              <span></span>
              <span>Prime</span>
              <span></span>
            </div>
            
            <div className="chart-legend">
              <div className="legend-item">
                <div className="legend-color plant"></div>
                <span>Plant</span>
              </div>
              <div className="legend-item">
                <div className="legend-color meq"></div>
                <span>MEQ</span>
              </div>
            </div>
          </div>
          
          <div className="preview-metrics">
            <div className="metric scale-on-hover">
              <span className="metric-value metric-display">{animatedMetrics.marbling}+</span>
              <span className="metric-label">Prime Grade %</span>
              <span className="metric-trend">↗ +0.3 avg</span>
            </div>
            <div className="metric scale-on-hover">
              <span className="metric-value metric-display">{animatedMetrics.accuracy}%</span>
              <span className="metric-label">Images Captured</span>
              <span className="metric-trend">↗ +0.2%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPreview; 